module.exports = __webpack_public_path__ + "static/media/passport_guide_white.80723889.svg";